import BrButton from '@govbr/react-components/lib/BrButton';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import config from './../../envConfig';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import iconeMobile from '../../assets/img/ilustra-mobile.svg';
import membrosFamiliaIcon from '../../assets/img/membros-familia-icon.svg';
import auth from '../../auth/Auth';
import authIdPositiva from '../../auth/AuthIdPositiva';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import { calcularTempoRestanteDecursoPrazo } from '../../common/DateUtil';
import { formatarNit } from '../../common/formatadores';
import Accordion, { SCROLL_OFFSET_NAV_FIXED } from '../../components/Accordion/Accordion';
import Card from '../../components/Card/Card';
import DadosBasicos from '../../components/DadosBasicos/DadosBasicos';
import FieldGroup from '../../components/FieldGroup/FieldGroup';
import MainContainer from '../../components/MainContainer/MainContainer';
import Message from '../../components/Message/Message';
import { TipoPerfil } from '../../model/TipoPerfil';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import { selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import styles from './ConsultaSimples.module.css';
import {
  getDadosFamilia,
  getDadosFamiliaIdPositiva,
  getDadosFamiliaRL,
  getDadosFamiliaRLIdPositiva,
  getDadosFamiliaRLMembro,
  getDadosFamiliaRLMembroIdPositiva,
  selectPessoa,
} from './consultaSimplesSlice';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { getDecursoPrazo, selectDecursoPrazo } from '../Suporte/SuporteSlice';
import { trackServiceSelect } from '../../common/tracker';

const ConsultaSimples: React.FC<any> = (props) => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const pessoa = useAppSelector(selectPessoa);

  let perfil = useAppSelector(selectPerfilCompleto);

  const dadosCadastraisRF = pessoa?.responsavelFamiliar;
  const dadosCadastraisRL = pessoa?.representanteLegal?.pessoaDadosCadastroDTO;
  const dadosFamilia = pessoa?.familiaDTO;

  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const govBrLogado = useAppSelector(selectGovBr).logado;
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);

  const decursoPrazo = useAppSelector(selectDecursoPrazo);

  useEffect(() => {
    dispatch(getDecursoPrazo());
  },[])

  useEffect(() => {
    if (auth.isAuthenticated()) {
      if (perfil.temRL) {
        if (perfil.tipoPerfil.codigo === TipoPerfil.REPRESENTANTE_LEGAL) {
          dispatch(getDadosFamiliaRL(perfil.identificador));
        } else {
          dispatch(getDadosFamiliaRLMembro(perfil.identificador));
        }
      } else {
        dispatch(getDadosFamilia(perfil.identificador));
      }
    } else if (authIdPositiva.isAuthenticated()) {
      if (perfil.temRL) {
        if (perfil.tipoPerfil.codigo === TipoPerfil.REPRESENTANTE_LEGAL) {
          dispatch(getDadosFamiliaRLIdPositiva(perfil.identificador));
        } else {
          dispatch(getDadosFamiliaRLMembroIdPositiva(perfil.identificador));
        }
      } else {
        dispatch(getDadosFamiliaIdPositiva(perfil.identificador));
      }
    }
  }, [dispatch, perfil]);


  useEffect(() => {
    if (props.location?.state?.mostrarIntegrantes) {
      const elem = document.getElementById('integrantes-familia');
      const rootEl = document.getElementById('root');
      if (elem && rootEl) {
        const rect = elem.getBoundingClientRect();
        let scrollTo = rect.top + rootEl.scrollTop;
        rootEl?.scrollTo({ top: scrollTo, behavior: 'smooth' });
      }
    }
  }, [props.location?.state?.mostrarIntegrantes]);

  useEffect(() => {
    if (props.location?.state?.mostrarRepresentanteLegal) {
      setTimeout(() => {
        const elem = document.getElementById('representante-legal');
        const rootEl = document.getElementById('root');
        if (elem && rootEl) {
          const rect = elem.getBoundingClientRect();
          let scrollTo = rect.top + rootEl.scrollTop-150;
          if (config.isCordova) {
            scrollTo = rect.top + rootEl.scrollTop-110;
          }
          rootEl?.scrollTo({ top: scrollTo, behavior: 'smooth' });
        }
      }, 1000);
    }
  }, [props.location?.state?.mostrarRepresentanteLegal]);

  const mostrarParentesco = (membro: any) => {
    if (membro?.tipoRelacaoParentescoRF?.nome === 'Pessoa Responsável pela Unidade Familiar - RF') {
      return 'Responsável Familiar - RF';
    }
    return membro?.tipoRelacaoParentescoRF?.nome;
  };

  const mostrarComprovante = () => {
    history.push('/comprovante');
  };
  const mostrarPostosAtendimento = () => {
    history.push('/posto-atendimento');
  };
  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva
      ? true
      : false;
  }
  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };
  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const mostrarBordaAmarela = (membro: any) => {
    return indicacaoDeObito(membro) || isFamiliaCadastradaEIntegranteEmCadastramento(membro.pessoaDadosCadastroDTO);
  };

  const isFamiliaCadastradaEIntegranteEmCadastramento = (dadosCadastraisMembro: any) => {
    return perfil?.tipoEstadoCadastralFamilia?.codigo === 3 && dadosCadastraisMembro?.tipoEstadoCadastralMembro?.codigo === 1;
  };

  const indicacaoDeObito = (membro: any) => {
    return membro.obito;
  };

  const indicacaoDeObitoRL = () => {
    return pessoa?.representanteLegal?.obito;
  };

  const mostrarBordaAmarelaRL = () => {
    return indicacaoDeObitoRL();
 };

  const mensagemObito = (membro: any) => {
    if (membro.isResponsavelFamiliar) {
      return `O responsável familiar está com registro de falecimento. Alguma pessoa da
        família deve ir ao CRAS atualizar o Cadastro Único.`;
    }
    const responsavel = perfil.temRF ? 'responsável familiar' : 'representante legal';
    return <>Pessoa com registro de falecimento. <br/>
      O {responsavel} deve ir ao CRAS para atualizar o Cadastro Único. <br/>
      Se o Cadastro Único não for atualizado, esta pessoa será excluída da família. </>;
  };

  const mensagemObitoRL = () => {
    return `O representante legal está com registro de falecimento. Vá ao CRAS atualizar o Cadastro Único.`;
  };

  const cardResponsavelFamiliar = (
    <>
      <div className={styles.cardHeader}>
        <i className={`fas fa-id-card-alt ${styles.cardIcon}`}></i>
        <span className={styles.cardTitle}>Responsável familiar</span>
      </div>
      <Accordion
        id="responsavel-familiar"
        title={dadosCadastraisRF?.nomePessoa}
        scroll
        scrollOffset={SCROLL_OFFSET_NAV_FIXED}
      >
        <Grid container spacing={2}>
          {dadosCadastraisRF?.nomeSocialApelidoPessoa && (
            <Grid item xs={12}>
              <FieldGroup
                label="Apelido/Nome social"
                value={dadosCadastraisRF?.nomeSocialApelidoPessoa}
                size="sm"
              />
            </Grid>
          )}
          <Grid item xs={6} sm={3}>
            <FieldGroup
              label="Estado cadastral"
              value={dadosCadastraisRF?.tipoEstadoCadastralMembro?.nome}
              size="sm"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <FieldGroup
              label="NIS, PIS ou PASEP"
              value={formatarNit(dadosCadastraisRF?.numeroNisPisPasepPessoa)}
              size="sm"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <FieldGroup
              label="Data de nascimento"
              value={
                dadosCadastraisRF?.dataNascimentoPessoa
                  ? moment(dadosCadastraisRF?.dataNascimentoPessoa).format('DD/MM/YYYY')
                  : null
              }
              size="sm"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <FieldGroup label="Sexo" value={dadosCadastraisRF?.tipoSexoPessoa?.nome} size="sm" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FieldGroup label="Filiação 1 (ou nome completo da mãe)" value={dadosCadastraisRF?.filiacao1} size="sm" />
          </Grid>
        </Grid>
      </Accordion>
    </>
  );

  const cardRepresentanteLegal = (
    <div id="representante-legal">
      <div  className={styles.cardHeader}>
        <i className={`fas fa-user-tie ${styles.cardIcon}`}></i>
        <span className={styles.cardTitle}>Representante legal</span>
      </div>
      <Accordion
        title={dadosCadastraisRL?.nomePessoa}
        className={mostrarBordaAmarelaRL() ? styles.alertCard : ''}
        open={props.location?.state?.mostrarRepresentanteLegal && indicacaoDeObitoRL()}
        scroll
        scrollOffset={SCROLL_OFFSET_NAV_FIXED}
      >
        {indicacaoDeObitoRL() && (
          <>
            <Message
              type={'warning'}
              title={mensagemObitoRL()}
              className={styles.message}
            />
            <p />
          </>
        )}
        <Grid container spacing={2}>
          <Grid item xs={6} sm={3}>
            <FieldGroup
              label="NIS, PIS ou PASEP"
              value={
                dadosCadastraisRL?.numeroNisPisPasepPessoa
                  ? formatarNit(dadosCadastraisRL.numeroNisPisPasepPessoa)
                  : ''
              }
              size="sm"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <FieldGroup
              label="Data de nascimento"
              value={
                dadosCadastraisRL?.dataNascimentoPessoa
                  ? moment(dadosCadastraisRL?.dataNascimentoPessoa).format('DD/MM/YYYY')
                  : null
              }
              size="sm"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <FieldGroup label="Sexo" value={dadosCadastraisRL?.tipoSexoPessoa?.nome} size="sm" />
          </Grid>
          <Grid item xs={6} sm={3}>
            <FieldGroup
              label="Representação legal"
              value={pessoa?.representanteLegal?.representacaoLegal?.nome}
              size="sm"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FieldGroup label="Filiação 1 (ou nome completo da mãe)" value={dadosCadastraisRL?.filiacao1} size="sm" />
          </Grid>
        </Grid>
      </Accordion>
    </div>
  );

  return (
    <MainContainer
      navHideArrow={!isLogado()}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      userNav={isLogado()}
      titleBarraAuxiliar="Dados resumidos da família"
      barraAuxiliar={true}
      padraoInicial={!isLogado()}
      navFixed={isLogado()}
      stoppedTitle={true}
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navLogout={isLogado() ? logout : undefined}
      >
      {pessoa && (
        <>
          <div className={styles.containerNome}>
            <div className={styles.text}>{pessoa?.pessoaDadosCadastroDTO?.nomePessoa}</div>
            <img src={iconeMobile} alt="Logo mobile" />
          </div>
          <div className={styles.container}>
            <DadosBasicos />
            <div className={styles.cardHeader}>
              <i className={`fas fa-address-book ${styles.cardIcon}`}></i>
              <span className={styles.cardTitle}>Dados da família</span>
            </div>
            <Card>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FieldGroup
                    label="Local do cadastro"
                    value={perfil?.municipio + ' - ' + perfil?.uf}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FieldGroup
                    label="Data do cadastro"
                    value={
                      perfil?.dataCadastroFamilia
                        ? moment(perfil?.dataCadastroFamilia).format('DD/MM/YYYY')
                        : null
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FieldGroup
                    label="Faixa de renda familiar total"
                    value={perfil?.faixaRendaFamiliarTotal}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FieldGroup
                    label="Faixa de renda familiar por pessoa (per capita)"
                    value={perfil?.faixaRendaFamiliarPorPessoa}
                  />
                </Grid>
              </Grid>
            </Card>

            {perfil.temRF && cardResponsavelFamiliar}
            {perfil.temRL && cardRepresentanteLegal}

            <div id="integrantes-familia" className={styles.cardHeader}>
              <img
                className={styles.cardImg}
                src={membrosFamiliaIcon}
                alt="Ícone de integrantes da família"
              />
              <span className={styles.cardTitle}>
                {dadosFamilia?.integranteFamiliaDTOs?.length} Integrante
                {dadosFamilia?.integranteFamiliaDTOs?.length > 1 ? 's' : ''} da família
              </span>
            </div>

            {dadosFamilia?.integranteFamiliaDTOs?.map((membro, index) => {
              const dadosCadastraisMembro = membro.pessoaDadosCadastroDTO;

              return (
                <Accordion
                  id={`membro-${index}`}
                  title={dadosCadastraisMembro?.nomePessoa}
                  subtitle={mostrarParentesco(membro)}
                  key={index}
                  open={props.location?.state?.mostrarIntegrantes && indicacaoDeObito(membro)}
                  scroll
                  className={mostrarBordaAmarela(membro) ? styles.alertCard : ''}
                  scrollOffset={SCROLL_OFFSET_NAV_FIXED}
                >
                  {indicacaoDeObito(membro) && (
                    <>
                      <Message
                        type={'warning'}
                        title={mensagemObito(membro)}
                        className={styles.message}
                      />
                      <p />
                    </>
                  )}
                  {!indicacaoDeObito(membro) && isFamiliaCadastradaEIntegranteEmCadastramento(dadosCadastraisMembro) && (
                    <>
                      <Message
                        type={'warning'}
                        title={`O cadastro dessa pessoa está incompleto. Caso deseje complementar, o ${perfil.temRF ? "responsável familiar" : "representante legal"} deve comparecer ao posto de cadastramento em até ${calcularTempoRestanteDecursoPrazo(
                          dadosCadastraisMembro.dataCadastramentoPessoa, decursoPrazo
                        )} dias, ou o cadastro dessa pessoa será excluído.`}
                        className={styles.message}
                      />
                      <p />
                    </>
                  )}

                  <Grid container spacing={2}>
                    {perfil.temRF && (
                      <Grid item xs={12}>
                        <FieldGroup
                          label="Parentesco com o(a) RF"
                          value={mostrarParentesco(membro)}
                          size="sm"
                        />
                      </Grid>
                    )}
                    {dadosCadastraisMembro?.nomeSocialApelidoPessoa && (
                      <Grid item xs={12}>
                        <FieldGroup
                          label="Apelido/Nome social"
                          value={dadosCadastraisMembro?.nomeSocialApelidoPessoa}
                          size="sm"
                        />
                      </Grid>
                    )}
                    <Grid item xs={6} sm={3}>
                      <FieldGroup
                        label="Estado cadastral"
                        value={dadosCadastraisMembro?.tipoEstadoCadastralMembro?.nome}
                        size="sm"
                      />
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <FieldGroup
                        label="NIS, PIS ou PASEP"
                        value={formatarNit(dadosCadastraisMembro?.numeroNisPisPasepPessoa)}
                        size="sm"
                      />
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <FieldGroup
                        label="Data de nascimento"
                        value={
                          dadosCadastraisMembro?.dataNascimentoPessoa
                            ? moment(dadosCadastraisMembro?.dataNascimentoPessoa).format(
                                'DD/MM/YYYY'
                              )
                            : null
                        }
                        size="sm"
                      />
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <FieldGroup
                        label="Sexo"
                        value={dadosCadastraisMembro?.tipoSexoPessoa?.nome}
                        size="sm"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FieldGroup
                        label="Filiação 1 (ou nome completo da mãe)"
                        value={dadosCadastraisMembro?.filiacao1}
                        size="sm"
                      />
                    </Grid>
                  </Grid>
                </Accordion>
              );
            })}
          </div>
          <div className={styles.moreOptionsWrapper}>

            <Accordion id="more-options" title="Mais opções" className={styles.moreOptions} scroll>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Card className={styles.moreOptionsCard}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <div className={styles.moreOptionsLeftPanel}>
                          <div className={styles.moreOptionsTitulo}>Comprovante de cadastro</div>
                          <BrButton
                            className={styles.moreOptionsButton}
                            onClick={() => mostrarComprovante()}
                          >
                            Gerar comprovante
                          </BrButton>
                        </div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className={styles.moreOptionsLegenda}>
                          Neste serviço você pode emitir o comprovante de cadastramento que serve para
                          provar que você está cadastrado no Cadastro Único.
                        </div>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Card className={styles.moreOptionsCard}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <div className={styles.moreOptionsLeftPanel}>
                          <div className={styles.moreOptionsTitulo}>Postos de atendimento</div>
                          <BrButton
                            className={styles.moreOptionsButton}
                            onClick={() => mostrarPostosAtendimento()}
                          >
                            Ver postos
                          </BrButton>
                        </div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className={styles.moreOptionsLegenda}>
                          Consulte aqui os postos de atendimento do Cadastro Único que ficam mais
                          próximos de onde você está.
                        </div>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Accordion>
          </div>
        </>
      )}
    </MainContainer>
  );
};

export default ConsultaSimples;
